<template>
  <footer>

    <h3><b>SimDhaara</b></h3>
    <h5 v-if="services.length">Services</h5>
    <div v-for="service of services" :key="service._id" class="nav-item">
        <router-link class="nav-link" :to="service.frontend_path">{{ service.service_name }}</router-link>
    </div>

  </footer>

</template>

<script>

export default {
  name: 'footer-main',
  props: {
  },
  created(){

  },
  methods: {
  },
  data() {
    return {
      services: []
    }
  }
}
</script>
<style scoped>
  .nav-link {

  }

  footer {
    background:#ededed;
    padding:15px;
    margin-top:2em;
  }

  h3,h5 {
    color: #707070;
  }

  footer a {
    color : #3E78BC;
  }

</style>